export const getBearerToken = (accessToken: string) => `Bearer ${accessToken}`;
